<template>
  <div class="uyh-intro-cta-container">
    <transition name="slide">
      <div class="hero-img-wrapper" v-if="isLanding()">
        <img src="@/assets/images/Desktop_Homepage_Hero.jpg" class="uyh-hero-img">
      </div>
    </transition>
    <svg svg-inline="" class="uyh-img-logo" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 175.3 56.52"><g data-name="Layer 2"><path class="cls-1" d="M2.84 8.93v7a3.55 3.55 0 0 0 .52 2.21 2.33 2.33 0 0 0 1.86.86 2.33 2.33 0 0 0 1.86-.84 3.55 3.55 0 0 0 .52-2.21v-7h2.84V16a5.13 5.13 0 0 1-1.3 4 5.57 5.57 0 0 1-4 1.5A5.35 5.35 0 0 1 1.31 20 5.1 5.1 0 0 1 0 16V8.93zm15.52 0h2.84v1.14a4.19 4.19 0 0 1 3.31-1.45 4.07 4.07 0 0 1 3.59 1.65 5.41 5.41 0 0 1 .76 3.39v7.49H26v-6.79c0-3.11-1.16-3.19-2.23-3.19-1.28 0-2.58.17-2.58 4.12v5.86h-2.83zM39.64 0v21.15H36.8V0zm36.49 12.68a4.81 4.81 0 0 0-3.46-1.51A3.65 3.65 0 0 0 70 12.24a3.86 3.86 0 0 0-1 2.81A4 4 0 0 0 70 18a3.71 3.71 0 0 0 2.59 1 4.74 4.74 0 0 0 3.51-1.57v3.17a6.77 6.77 0 0 1-3.72.95 6 6 0 0 1-4.64-1.79A6.36 6.36 0 0 1 66 15.14a6.53 6.53 0 0 1 1.86-4.73 6.65 6.65 0 0 1 4.9-1.79 6.53 6.53 0 0 1 3.34.87zM86 0v13l4-4.09h3.77L88.54 14l5.62 7.14h-3.59l-4-5.23-.52.53v4.7H83.2V0zm29.07 19.23l-5.22-10.3h3.42l3.48 7.14 3.54-7.14h3.19l-9.72 18.86h-3.19zm26.54-4.18a6.53 6.53 0 0 1-13.06 0 6.53 6.53 0 0 1 13.06 0zm-2.9 0a3.53 3.53 0 0 0-3.63-3.91c-1.8 0-3.62 1.13-3.62 3.91 0 2.35 1.39 3.89 3.62 3.89s3.63-1.51 3.63-3.86zm13.04-6.12v7a3.49 3.49 0 0 0 .53 2.21 2.47 2.47 0 0 0 3.71 0 3.55 3.55 0 0 0 .52-2.21v-7h2.84V16a5.13 5.13 0 0 1-1.3 4 5.56 5.56 0 0 1-4 1.5 5.36 5.36 0 0 1-3.86-1.5 5.14 5.14 0 0 1-1.31-4V8.93zm15.55 0h2.84V10a4.78 4.78 0 0 1 1.19-1 3.26 3.26 0 0 1 1.74-.4 4.14 4.14 0 0 1 2.23.58l-1.16 2.58a2.54 2.54 0 0 0-1.45-.44 2.23 2.23 0 0 0-1.77.67 3.94 3.94 0 0 0-.78 2.81v6.33h-2.84zM49.59 35h2.84v10a4.37 4.37 0 0 1 3.28-1.36 4.18 4.18 0 0 1 3.6 1.65 6 6 0 0 1 .78 3.39v7.49h-2.84v-7.25a2.93 2.93 0 0 0-.55-2.11 2.14 2.14 0 0 0-1.6-.64 2.52 2.52 0 0 0-2.09 1 5.54 5.54 0 0 0-.58 3.08v5.89h-2.84zm29.06 18.36a6.48 6.48 0 0 1-2.06 2.24 6.8 6.8 0 0 1-3.6.92A5.43 5.43 0 0 1 68.87 55a6.56 6.56 0 0 1-1.79-4.67 7.13 7.13 0 0 1 1.94-5 5.55 5.55 0 0 1 4.09-1.65A5.3 5.3 0 0 1 77 45.21a7.36 7.36 0 0 1 1.71 5.16v.35H70a4.05 4.05 0 0 0 1 2.47 3.41 3.41 0 0 0 4.12.17A4.51 4.51 0 0 0 76.27 52zm-2.81-5a3 3 0 0 0-.84-1.61 2.74 2.74 0 0 0-1.92-.7 2.78 2.78 0 0 0-2 .78 3.23 3.23 0 0 0-.87 1.57zM95 43.93h2.84v12.22H95v-1.28a4.7 4.7 0 0 1-3.66 1.65c-3.77 0-5.92-3.13-5.92-6.49 0-4 2.73-6.41 5.95-6.41A4.45 4.45 0 0 1 95 45.36zm-6.67 6.15c0 2.12 1.33 3.89 3.39 3.89 1.8 0 3.45-1.3 3.45-3.86s-1.65-3.94-3.45-3.94c-2.08 0-3.41 1.74-3.41 3.91zm17.43-6.15h2.85V45a4.74 4.74 0 0 1 1.18-1 3.32 3.32 0 0 1 1.75-.4 4.16 4.16 0 0 1 2.23.58l-1.16 2.58a2.56 2.56 0 0 0-1.45-.44 2.22 2.22 0 0 0-1.77.67 3.94 3.94 0 0 0-.78 2.81v6.33h-2.85zm17.49 2.61v9.61h-2.84v-9.61h-1.19v-2.61h1.19v-4.46h2.84v4.46h2.17v2.61zM50.44 21.36v-.28c0-.45 0-.69.59-1.66l1.35-2.33-.46-.23c-.48.8-1.26 2.13-2.87 2.13a2.82 2.82 0 0 1-2.83-3c0-1.64 1.22-2.9 2.72-4.19l4.14-3.52h.26l4.14 3.53c1.52 1.27 2.74 2.51 2.74 4.19a2.86 2.86 0 0 1-2.86 3c-1.61 0-2.4-1.33-2.88-2.13l-.46.23 1.35 2.33a2.78 2.78 0 0 1 .63 1.65v.28z" fill="#21362c" data-name="Layer 1"/></g></svg>
    <transition name="fade" mode="out-in">
      <router-view v-on:step-update="stepUpdate"/>
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'intro_cta',
    data() {
      return {
        step: 'landing',
        windowWidth: 0
      }
    },
    methods: {
      stepUpdate: function(stepUpdate) {
        this.step = stepUpdate;
      },
      isLanding: function() {
        return this.step == 'landing';
      },
      widowWidth: function() {
        this.windowWidth = window.innerWidth;
      },
    },
    mounted: function() {
      this.$nextTick(function(){
        this.widowWidth();
        window.addEventListener('resize', this.widowWidth);
      });
    },
    destroyed: function() {
      document.removeEventListener('resize', this.widowWidth);
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
  .responsivesite #wrapper #uyh-app,
  #uyh-app {
    .uyh-intro-cta-container {
      overflow: hidden;
      padding-bottom: 20px;
      position: relative;
    }

    .hero-img-wrapper,
    .uyh-img-logo {
      display: block;
      left: 50%;
      position: relative;
      transform: translateX(-50%);
    }

    .hero-img-wrapper {
      max-width: 54%;
      overflow: hidden;

      &:before {
        content: '';
        display: block;
        padding-top: calc(329 / 890 * 100%);
        position: relative;
        transition: all 0.45s ease-in-out;
      }

      &.slide-leave-active,
      &.slide-enter-active {
        transition: all 0.45s ease-in-out;
        &:before {
          transition: all 0.45s ease-in-out;
        }
      }
      &.slide-leave,
      &.slide-leave-to {
        opacity: 0;
        &:before {
          padding-top: 0;
        }
      }
      &.slide-enter,
      &.slide-enter-to {
        opacity: 0;
        &:before {
          padding-top: 0;
        }
      }
    }
    .uyh-hero-img {
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
    }
    .uyh-img-logo {
      max-width: 23.25%;
      min-width: 265px;
      padding-top: 50px;
    }

    // Landscape Tablet
    @media screen and (max-width: 1199px) {
      .hero-img-wrapper {
        max-width: 63%;
      }
    }

    // Portrait Tablet
    @media screen and (max-width: 1023px) {
      .hero-img-wrapper {
        max-width: 100%;
      }
    }

    // Mobile
    @media screen and (max-width: 767px) {
      .hero-img-wrapper {
        max-width: 130%;
      }
    }

    .fade-leave-active,
    .fade-enter-active {
      transition: all 0.5s ease-in-out;
    }

    .fade-leave,
    .fade-leave-to,
    .fade-enter,
    .fade-enter-to {
      opacity: 0;
      transform: translateY(15px);
    }
  }
</style>
